<div class="d-flex mt-3">
  <div class="form-inline d-flex align-items-center">
    <div class="btn-group" btnRadioGroup [(ngModel)]="value" (ngModelChange)="notifyChanged()">
      <label *ngFor="let option of options"
              class="btn"
              [class.btn-primary]="value == option.value"
              [class.btn-default]="value != option.value"
              [btnRadio]="option.value"
              >{{option.label}}</label>
    </div>
  </div>
</div>